import { types } from 'mobx-state-tree';

import CurrentOrderProduct from './CurrentOrderProduct';
import OrderPayment from './OrderPayment';
import OrderShipping from './OrderShipping';
import OrderTotalValue from './OrderTotalValue';
import OrderStatusHistoryEntry from './OrderStatusHistoryEntry';

const CurrentOrder = types
  .model('CurrentOrder', {
    analytics_currency: types.string,
    campaign_code: types.maybeNull(types.string),
    confirmation_email: types.maybeNull(types.string),
    currency: types.string,
    date_purchased: types.maybeNull(types.string),
    external_type: types.maybeNull(types.string),
    has_licensed_products: types.boolean,
    html_widget: types.maybeNull(types.string),
    id: types.number,
    id_for_analytics: types.string,
    is_seen: types.boolean,
    merchant_name: types.maybeNull(types.string),
    payment: types.maybeNull(OrderPayment),
    payment_method_messages: types.optional(types.array(types.string), []),
    products: types.array(CurrentOrderProduct),
    real_total: types.number,
    receipt_url: types.maybeNull(types.string),
    seller_name: types.maybeNull(types.string),
    shipping: types.maybeNull(OrderShipping),
    status_history: types.optional(types.array(OrderStatusHistoryEntry), []),
    totals: types.array(OrderTotalValue),
    tracking_pixels: types.array(types.string),
    tracking_url: types.maybeNull(types.string),
    type: types.string
  })
  .views((self) => {
    return {
      get paymentAddress() {
        return self.payment && self.payment.address;
      },
      get shippingAddress() {
        return self.shipping && self.shipping.address;
      },
      get shippingMethod() {
        return self.shipping && self.shipping.method;
      },
      get paymentMethod() {
        return self.payment && self.payment.method;
      },
      get pickupPoint() {
        return self.shipping && self.shipping.pick_up_point;
      }
    };
  });

export default CurrentOrder;



// WEBPACK FOOTER //
// ./src/models/CurrentOrder.js